import { Injectable } from '@angular/core';
import {
  NgEntityService,
  NgEntityServiceConfig,
} from '@datorama/akita-ng-entity-service';
import { tap } from 'rxjs/operators';
import { AuthQuery, AuthStore, serializePreferences } from '../auth';
import { User, UserPreference } from './user.model';
import { UserState, UserStore } from './user.store';

@Injectable()
@NgEntityServiceConfig({
  resourceName: 'users',
})
export class UserService extends NgEntityService<UserState> {
  constructor(
    protected store: UserStore,
    private authQuery: AuthQuery,
    private authStore: AuthStore
  ) {
    super(store);
  }

  sendBulkUser(users: User[]) {
    return this.getHttp().post(`${this.api}/bulk`, users);
  }

  addUsers(users: User[]) {
    this.store.upsertMany(users);
  }

  getUserInfo(userId: string) {
    return this.getHttp().get<User>(`${this.api}${userId ? '/' + userId : ''}`);
  }

  upsertPreferences(preferences: UserPreference[]) {
    return this.getHttp()
      .put<UserPreference[]>(`${this.api}/preferences`, preferences)
      .pipe(
        tap((preferences) =>
          this.authStore.update((state) => ({
            user: {
              ...state.user,

              preferences: serializePreferences(preferences),
            },
          }))
        )
      );
  }

  getUserPreference<T>(name: string): T | null {
    const { user } = this.authQuery.getValue();
    const preference = (user?.preferences || []).find(
      (pref) => pref.name === name
    );
    return preference?.value as any;
  }
}
